<template>
    <div class="container">
        <canvas ref="canvas" width="900" height="500"></canvas>
    </div>
</template>
<script>

    import { Bar, mixins } from 'vue-chartjs'
    import chroma from "chroma-js";
    import ChartDataLabels from "chartjs-plugin-labels";


    export default {
        name: 'Widget',
        extends: Bar,
        props: ['dataset','labels','options','chartData'],
        mixins: [mixins.reactiveProp],
        data () {
            return {
                colors: [
                    'rgba(18, 183, 151, #)',
                    'rgba(18, 161, 253, #)',
                    'rgba(44, 156, 169, #)',
                    'rgba(1, 240, 170, #)',
                    'rgba(247, 0, 65, #)',
                    'rgba(187, 1, 240, #)',
                    'rgba(1, 170, 240, #)',
                    'rgba(1, 240, 170, #)'
                ]
            }
        },
        mounted: function(){

            this.renderViewChart()

        },
        methods: {
          renderColors: function(count, transparentBackgroundTop, transparentBackgroundBottom)
          {
            /*
            let colorss = chroma
                .scale(window.chartColors)
                .domain([0,0.25,1])
                .mode('lch')
                .colors(count * 2);
                */

            let colors = window.chartColors(count);

            let backgroundColors = [];
            let hoverBackgroundColors = [];

            for(let i=0 ; i<colors.length ; i++)
            {

              var c = 'rgba(' + chroma(colors[i]).rgb().join(',') + ', #)';

              var gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 400, 0, 100)
              gradient.addColorStop(0, c.replace('#', transparentBackgroundTop))
              gradient.addColorStop(1, c.replace('#', transparentBackgroundBottom))

              backgroundColors.push(gradient);
              hoverBackgroundColors.push(colors[i]);
            }

            return {backgroundColors:backgroundColors, hoverBackgroundColors:hoverBackgroundColors}
          },
          renderViewChart: function()
          {

            let borderWidth = 2;
            let transparentBackgroundTop = 0.8;
            let transparentBackgroundBottom = 0.3;
            if( this.options.__custom && this.options.__custom.borderWidth !== undefined ){ borderWidth = this.options.__custom.borderWidth; }
            if( this.options.__custom && this.options.__custom.transparentBackgroundTop !== undefined ){ transparentBackgroundTop = this.options.__custom.transparentBackgroundTop; }
            if( this.options.__custom && this.options.__custom.transparentBackgroundBottom !== undefined ){ transparentBackgroundBottom = this.options.__custom.transparentBackgroundBottom; }


            let count = Object.keys(this.dataset).length;
            let backgroundColor = this.renderColors(count, transparentBackgroundTop, transparentBackgroundBottom).backgroundColors;
            let hoverBackgroundColor = this.renderColors(count, transparentBackgroundTop, transparentBackgroundBottom).hoverBackgroundColors;

            var datasets = [];
            let colorIndex = 0
            for(var index in this.dataset) {
              let element = this.dataset[index];

              let bgColor = backgroundColor[colorIndex]
              if( element.backgroundColor && element.backgroundColor != "transparent" )
              {
                let elementColor = 'rgba(' + chroma(element.backgroundColor).rgb().join(',') + ', #)';
                let elementGradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 400, 0, 100)
                elementGradient.addColorStop(0, elementColor.replace('#', transparentBackgroundTop))
                elementGradient.addColorStop(1, elementColor.replace('#', transparentBackgroundBottom))
                bgColor = elementGradient
              }

              let bgColorHover = hoverBackgroundColor[colorIndex]
              if( element.backgroundColor && element.backgroundColor != "transparent" )
              {
                let elementColor = 'rgba(' + chroma(element.backgroundColor).rgb().join(',') + ', #)';
                let elementGradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 400, 0, 100)
                elementGradient.addColorStop(0, elementColor.replace('#', transparentBackgroundTop))
                elementGradient.addColorStop(1, elementColor.replace('#', transparentBackgroundBottom))
                bgColorHover = elementGradient
              }

              let borderColor = element.borderColor ? 'rgba(' + chroma(element.borderColor).rgb().join(',') + ', 1)' : bgColorHover;

              let data = element;
              data.label = element.name ? element.name : element.label
              data.backgroundColor = element.backgroundColor || bgColor || 'transparent'
              data.data = element.data
              data.borderColor = borderColor
              data.pointBorderColor = '#ffffff'
              data.pointBackgroundColor = borderColor
              data.pointHoverBorderColor = borderColor
              data.pointBorderWidth = (element.borderWidth || borderWidth) - 1
              data.borderWidth = element.borderWidth || borderWidth
              data.pointHoverRadius = 4
              data.pointHoverBorderWidth = 2
              data.pointRadius = 3
              data.lineTension = 0

              datasets.push(data);

              colorIndex ++

            };


            this.renderChart({
              labels: this.labels,
              responsive: true,
              maintainAspectRatio: true,
              datasets: datasets
            }, this.options)
          }
        },
        watch: {
            dataset () {
                this.renderViewChart()
            }
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/chart/Bar.vue